// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"Service_stepsNav__1oPNm","navLink":"Service_navLink__1IUfE","active":"Service_active__2ZBQS"};